module.exports = __webpack_public_path__ + "static/img/unMute_camera2.e9a43ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/unMute_camera2.png
// module id = Ji1K
// module chunks = 24